import { Component, OnInit, computed, signal, inject, output } from '@angular/core';
import { MaterialModule } from 'src/app/shared/material.module';
import { IEmployeeSimple } from 'src/app/shared/models';
import { EmployeeService } from 'src/app/shared/services/employee.service';
import { HttpClient } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-employee-search',
  imports: [MaterialModule, TranslateModule],
  templateUrl: './employee-search.component.html',
  styleUrls: ['./employee-search.component.scss'],
})
export class EmployeeSearchComponent implements OnInit {
  service = inject(EmployeeService);
  http = inject(HttpClient);

  readonly clear = output<void>();
  readonly onselect = output<number>();

  employeeList = signal<IEmployeeSimple[]>([]);
  query = signal('');

  filteredEmployee = computed(() =>
    this.employeeList().filter((employee) =>
      employee.fullName.toLocaleLowerCase().includes(this.query().toLocaleLowerCase()),
    ),
  );

  ngOnInit(): void {
    this.service.getAllEmployeesSimple().subscribe((data) => this.employeeList.set(data));
  }

  onInput(value: string) {
    this.query.set(value);
    if (value === '') this.clear.emit();
  }

  select(name: string) {
    const id = this.employeeList().find((employee) => employee.fullName === name).id;

    this.onselect.emit(id);
  }
}
